export enum CookieName {
  CookieAgreement = 'cookieAgreement',
}
